<template>
    <vue-slider
        :value="value"
        :enable-cross="false"
        :min-range="1"
        :tooltip-formatter="formatter"
        @change="onInput"
    />
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/material.css';

export default {
    name: 'slider',
    components: { VueSlider },

    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        onInput(newValue) {
            this.$emit('input', newValue);
        },

        formatter(value) {
            return `${ value }%`;
        },
    },
};
</script>
